export default __webpack_public_path__ + "static/media/ml.00d7a730.png";